import { themePalettes } from './variables';

// New-look text is Green200, as in quote, where all text is green200 save deliberate exceptions (Amber's board).
// Style files across staff-fe hard-code the mid green as a text color, so this JSS plugin rewrites `color` instead of
// each file. Fills, borders and SVG icons keep the mid green. Classic's JSS instance doesn't use it.
// An exception writes the mid green in rgb() form, which this leaves alone (the outlined Label in theme.jsx).
const { green_75: MID_GREEN, green_100: GREEN_200 } = themePalettes.reskin.colorPalette;
const MID_GREEN_TEXT = new RegExp(`^\\s*${MID_GREEN}\\s*(!important)?\\s*$`, 'i');

export const reskinTextColor = (color) => {
  const match = typeof color === 'string' && MID_GREEN_TEXT.exec(color);
  if (!match) {
    return color;
  }
  return match[1] ? `${GREEN_200} !important` : GREEN_200;
};

const reskinTextColorsPlugin = () => ({
  onProcessStyle(style) {
    if (!style || style.color === undefined) {
      return style;
    }
    const color = reskinTextColor(style.color);
    return color === style.color ? style : { ...style, color };
  }
});

export default reskinTextColorsPlugin;
